import { render, staticRenderFns } from "./LanguageSelectorModal.vue?vue&type=template&id=57d5e8c2&scoped=true&lang=pug&"
import script from "./LanguageSelectorModal.vue?vue&type=script&lang=js&"
export * from "./LanguageSelectorModal.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSelectorModal.vue?vue&type=style&index=0&id=57d5e8c2&scoped=true&lang=sass&"
import style1 from "./LanguageSelectorModal.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5e8c2",
  null
  
)

export default component.exports